import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import AxiosInstance from "./AxiosInstance";

function parseErrorMessage(err, fallback) {
  if (!err.response?.data) {
    return fallback;
  }
  if (err.response.data instanceof ArrayBuffer) {
    try {
      const text = new TextDecoder().decode(err.response.data);
      const json = JSON.parse(text);
      return json.message || json.error || fallback;
    } catch {
      return fallback;
    }
  }
  return err.response?.data?.message || fallback;
}

function triggerPdfDownload(data, headers, defaultFileName) {
  const blob = new Blob([data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  const disposition = headers["content-disposition"];
  let fileName = defaultFileName;
  if (disposition) {
    const match = disposition.match(/filename="?([^"]+)"?/);
    if (match?.[1]) {
      fileName = match[1];
    }
  }

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export async function downloadPdfFromUrl(url, defaultFileName = "registration.pdf") {
  try {
    const res = await AxiosInstance.get(url, {
      responseType: "arraybuffer",
    });
    triggerPdfDownload(res.data, res.headers, defaultFileName);
    toast.success("PDF downloaded successfully");
  } catch (err) {
    toast.error(parseErrorMessage(err, "Failed to download PDF"));
  }
}

export function downloadRegistrationPdf() {
  return downloadPdfFromUrl(`${BaseUrl}/api/auth/fetch-user-data/pdf`, "registration.pdf");
}

export function downloadApplicationPdf(appId, scope = "admin") {
  const path =
    scope === "hod"
      ? `${BaseUrl}/api/hod/view-capf-application/${appId}/pdf`
      : `${BaseUrl}/api/admin/view-capf-application/${appId}/pdf`;
  return downloadPdfFromUrl(path, `application-${appId}.pdf`);
}
